module.exports = __webpack_public_path__ + "static/media/error-500.eadbb377.svg";